// lodash
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import concat from 'lodash/concat';
import get from 'lodash/get';
import find from 'lodash/find';
// constants
import paymentTypeConstants from '../../constants/paymentTypeConstants';

export default function getAppliedPayments(paymentState, returnedPayments) {
  const removedPayments = filter(paymentState, payment => payment.isRemoved);
  const payments = !isEmpty(removedPayments) ? concat(returnedPayments, removedPayments) : returnedPayments;

  return payments.map((payment) => {
    const appliedPayment = returnedPayments.filter(appliedPayment => payment.id === appliedPayment.id)[0];
    const previousStateEntry = find(paymentState, { id: payment.id });

    const isGiftCard = get(previousStateEntry, 'type', '') === paymentTypeConstants.GIFT_CARD;
    const isGiftVoucher = get(previousStateEntry, 'type', '') === paymentTypeConstants.GIFT_VOUCHER;

    return appliedPayment ? {
      ...appliedPayment,
      details: {
        ...appliedPayment.details,
        ...(isGiftCard && {
          pin: previousStateEntry.details.pin,
          cardNumber: previousStateEntry.details.cardNumber,
        }),
        ...(isGiftVoucher && {
          securityCode: previousStateEntry.details.securityCode,
          serialNumber: previousStateEntry.details.serialNumber,
        }),
      },
    } : payment;
  });
}
